import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function StepSummaryItem(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-245991817" + " " + 'container',
      children: [/*#__PURE__*/_jsxs("div", {
        className: "jsx-245991817" + " " + 'title',
        children: [title, ":"]
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-245991817" + " " + 'content',
        children: children
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "245991817",
      children: [".container.jsx-245991817{display:grid;grid-template-columns:130px auto;grid-gap:10px;margin-bottom:20px;}", "@media(max-width:400px){.container.jsx-245991817{display:block;}}", "@media(min-width:576px){.container.jsx-245991817{grid-template-columns:200px auto;}}", ".container.jsx-245991817:last-child{margin-bottom:0;}", ".title.jsx-245991817{font-weight:700;}", "@media(max-width:400px){.title.jsx-245991817{margin-bottom:5px;}}"]
    })]
  });
}